import React, { useState } from "react";
import { setParam, push, resetToFirstPage } from "api/search/filterUrlMaker";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { firstItem } from "lib/utils";
import { toLocaleYYYYMMDD, earliestDate } from "lib/dateUtils";
import "./datepicker.css";
import { parseDate } from "pages/redesign/publications/api/searchRequest/parseDates";
import { ListGroup } from "react-bootstrap";
import { _t } from "../../../../../app/i18n/i18n";

export const ListItem = ({
  label,
  isActive,
  isTranslate,
  onClick,
  children = null,
  className = "m-0 p-2 cursor-pointer ",
}) => (
  <ListGroup.Item className={className + (isActive ? " left-border-highlight text-primary " : "")} onClick={onClick}>
    <span>{isTranslate ? _t(label) : label}</span>
    {children}
  </ListGroup.Item>
);

// custom date picker list items for search page,
export const SearchDatePicker = ({ option, label = option, ...props }) => {
  const dateFrom = getDateFromUrl(props.filter.Date);
  const dateTo = getDateFromUrl(props.filter.DateTo);

  const fromMax = earliestDate(dateTo, new Date());
  const toMin = dateFrom;
  const toMax = new Date();

  switch (label) {
    case "From date":
      return <DatePicker {...props} label={label} category="Date" maxDate={fromMax} defaultValue={dateFrom} />;

    case "To date":
      return (
        <DatePicker {...props} label={label} category="DateTo" minDate={toMin} maxDate={toMax} defaultValue={dateTo} />
      );

    default:
      return null;
  }
};

const DatePicker = ({ category, label, placeholderText, maxDate, minDate, defaultValue, ...props }) => {
  const [date, setDate] = useState(defaultValue);

  return (
    <ListItem
      {...props}
      label={label}
      isActive={isActive({ category, ...props })}
      className="m-0 p-2 search-datepicker"
    >
      <ReactDatePicker
        selected={date}
        onChange={(date) => {
          setDate(date);
          push(resetToFirstPage(setParam(category, toLocaleYYYYMMDD(date))));
        }}
        placeholderText={"yyyy/mm/dd"}
        dateFormat={"yyyy-MM-dd"}
        minDate={minDate || new Date("1997-01-01")}
        maxDate={maxDate}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        className="border-0"
        popperClassName="datepicker-popper"
      />
    </ListItem>
  );
};

const isActive = ({ filter, category }) => {
  const date = firstItem(filter[category]);
  if (date && isStandardDate(date)) return false;
  return date;
};

export const isStandardDate = (date) => ["1 Week", "1 Month", "6 Months", "1 Year", "All Time"].includes(date);

const getDateFromUrl = (arrDate) => {
  const strDate = arrDate && firstItem(arrDate);
  if (strDate && strDate.includes("Range")) return null;
  if (isStandardDate(strDate)) return parseDate(strDate);
  const date = strDate && new Date(strDate + "T00:00:00");
  return date;
};
